/**
 * Studio cross-tab memory + deep links.
 *
 * The two studio tabs (Native Widgets / Component Bootstrap) are SEPARATE
 * routes, so the standard tab unmounts when you hop to bootstrap and its state
 * — which widget is open, the graph reading, the focused module, the page —
 * lives only in the URL. The tab bar navigated to a bare `/studio/standard`,
 * dropping all of it. Park the last standard search here so returning to the
 * tab restores it. Module-level on purpose: nothing else survives the unmount.
 */
let standardSearch = '';

/** Called while the standard tab is mounted; `s` is `params.toString()` (no `?`). */
export function rememberStandardSearch(s) {
  standardSearch = s ? (s.startsWith('?') ? s : `?${s}`) : '';
}

/** The remembered standard search, `?`-prefixed, or '' if none yet. */
export function recallStandardSearch() {
  return standardSearch;
}

/** Deep link into the Component Bootstrap, LOCATED on one component. The bootstrap
 *  browser reads `?component=` and scrolls that card into view (README-anchor style,
 *  full library still visible) rather than filtering the list down to it. */
export function bootstrapHref(componentId) {
  return `/playground/widget-native/studio/bootstrap?component=${encodeURIComponent(componentId)}`;
}

/** The DOM id the bootstrap browser stamps on each component card, so a deep link
 *  can scroll straight to it — the anchor a `?component=<id>` URL resolves to. */
export function bootstrapAnchorId(componentId) {
  return `bootstrap-comp-${componentId}`;
}
